export const ADMIN_API_URL = `https://us-central1-vanguard-e2803.cloudfunctions.net/admins`;
export const API_URL = `https://us-central1-vanguard-e2803.cloudfunctions.net`;
